import { Injectable, inject } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AppConfig } from 'src/app/app-config';
import { APP_CONFIG } from 'src/app/app-config.token';
import { Permission } from 'src/app/common/enums/permissions';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { WorkerProfileAccessService } from 'src/app/data/worker-profile-access.service';

@Injectable({
  providedIn: 'root',
})
export class DeclarationGuard {
  private config = inject<AppConfig>(APP_CONFIG);
  private router = inject(Router);
  private authService = inject(AuthService);
  private workerProfileAccessService = inject(WorkerProfileAccessService);

  isLoggedUserProfile: boolean;
  constructor() { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.workerProfileAccessService.isLoggedUserProfile$.subscribe((value) => (this.isLoggedUserProfile = value));

    if (
      !this.authService.hasPermission(Permission.ShowAllDeclarations) &&
      !this.authService.hasPermission(Permission.ShowEmployerObjectDeclarations) &&
      !this.authService.hasPermission(Permission.ManageAllExternalWorkersList) &&
      !this.authService.hasPermission(Permission.ManageAsAExternalWorker) &&
      !this.isLoggedUserProfile
    ) {
      const workerId = +new RegExp('\\d+').exec(state.url)[0];
      this.router.navigate(['/profile', workerId, 'statements']);
      return false;
    }

    return true;
  }
}
